/* tslint:disable */
/* eslint-disable */
/* @relayHash 1a7c617ad28204348e741f47b6dd2749 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type headerRootQueryVariables = {
    hasUserId: boolean;
    hasTradeUserId: boolean;
    previewKey?: string | null;
    userId: string;
    userIds: Array<string | null>;
    fetchRegionalInfo: boolean;
    fetchTradeNav: boolean;
    fetchNav: boolean;
    zipCode: string;
    userCountryCode?: string | null;
    hasSessionCountryCode: boolean;
    localRecentHistoryItemIds?: Array<string | null> | null;
    fetchUserRecentHistoryItem?: boolean | null;
    checkoutUserId: string;
    hasCheckoutUserId: boolean;
};
export type headerRootQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"Header_viewer">;
    };
};
export type headerRootQuery = {
    readonly response: headerRootQueryResponse;
    readonly variables: headerRootQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "hasUserId",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasTradeUserId",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "previewKey",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userIds",
    "type": "[String]!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchRegionalInfo",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchTradeNav",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchNav",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "zipCode",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userCountryCode",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "hasSessionCountryCode",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "localRecentHistoryItemIds",
    "type": "[String]",
    "defaultValue": ([]/*: any*/)
  },
  {
    "kind": "LocalArgument",
    "name": "fetchUserRecentHistoryItem",
    "type": "Boolean",
    "defaultValue": false
  },
  {
    "kind": "LocalArgument",
    "name": "checkoutUserId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasCheckoutUserId",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "Variable",
  "name": "rootId",
  "variableName": "previewKey"
},
v3 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "path",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "isLinkable",
    "args": null,
    "storageKey": null
  }
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "linkData",
  "storageKey": null,
  "args": null,
  "concreteType": "LinkData",
  "plural": false,
  "selections": (v3/*: any*/)
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v7 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "modules",
    "storageKey": null,
    "args": null,
    "concreteType": "NavigationModule",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "imageUrl",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "imageLinkData",
        "storageKey": null,
        "args": null,
        "concreteType": "LinkData",
        "plural": false,
        "selections": (v3/*: any*/)
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "imageTitlePrimary",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "imageTitleSecondary",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "imageHeight",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "imageWidth",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "imageLink",
        "args": null,
        "storageKey": null
      },
      (v4/*: any*/),
      (v5/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isHighlighted",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "items",
        "storageKey": null,
        "args": null,
        "concreteType": "NavigationTopLevel",
        "plural": true,
        "selections": [
          (v6/*: any*/),
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "column",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "items",
            "storageKey": null,
            "args": null,
            "concreteType": "NavigationItem",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v1/*: any*/)
            ]
          },
          (v1/*: any*/)
        ]
      },
      (v6/*: any*/),
      (v1/*: any*/)
    ]
  },
  (v1/*: any*/)
],
v8 = {
  "kind": "Variable",
  "name": "userIds",
  "variableName": "userIds"
},
v9 = [
  {
    "kind": "Literal",
    "name": "relationshipType",
    "value": "TRADE"
  },
  (v8/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayName",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v14 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "totalResults",
    "args": null,
    "storageKey": null
  }
],
v15 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdDate",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "zipCode",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v21 = [
  (v18/*: any*/),
  (v20/*: any*/)
],
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": "thumbnail",
  "name": "firstPhotoWebPath",
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "thumb"
    }
  ],
  "storageKey": "firstPhotoWebPath(size:\"thumb\")"
},
v24 = [
  {
    "kind": "Variable",
    "name": "excludeItemPks",
    "variableName": "localRecentHistoryItemIds"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 12
  }
],
v25 = [
  (v12/*: any*/)
],
v26 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userIds"
},
v27 = {
  "kind": "Literal",
  "name": "first",
  "value": 0
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "countryCode",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "zipCode"
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "headerRootQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Header_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "headerRootQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": "isNotificationsEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "NOTIFICATIONS"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"NOTIFICATIONS\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isFavoritesEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "FAVORITES"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isCartEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "CART"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"CART\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isMessageCenterEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "MESSAGE_CENTER"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isAutomatedOfferNotificationDisabled",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "disableAutomatedOfferBellNotification"
              }
            ],
            "storageKey": "isEnabled(key:\"disableAutomatedOfferBellNotification\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSuggestionsFeatureEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "SEARCH_BAR_SUGGESTIONS"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"SEARCH_BAR_SUGGESTIONS\")"
          },
          (v1/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchNav",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "navigation",
                "storageKey": null,
                "args": [
                  (v2/*: any*/)
                ],
                "concreteType": "Navigation",
                "plural": false,
                "selections": (v7/*: any*/)
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchTradeNav",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "tradeNavigation",
                "name": "navigation",
                "storageKey": null,
                "args": [
                  (v2/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "userType",
                    "value": "TRADE"
                  }
                ],
                "concreteType": "Navigation",
                "plural": false,
                "selections": (v7/*: any*/)
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasTradeUserId",
            "selections": [
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": "tradeRep",
                    "name": "userRelationships",
                    "storageKey": null,
                    "args": (v9/*: any*/),
                    "concreteType": "UserRelationship",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "userDataB",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": true,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "type": "TradeRepData",
                            "selections": [
                              (v11/*: any*/),
                              (v12/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "photoUrl",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      (v1/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "portfolios",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  },
                  {
                    "kind": "Literal",
                    "name": "portfolioTypes",
                    "value": [
                      "CART"
                    ]
                  },
                  (v8/*: any*/)
                ],
                "concreteType": "PortfoliosConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfoliosEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioV2",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "items",
                            "storageKey": "items(first:3)",
                            "args": [
                              (v13/*: any*/)
                            ],
                            "concreteType": "PortfolioItemsConnection",
                            "plural": false,
                            "selections": (v14/*: any*/)
                          },
                          (v1/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "conversations",
                "storageKey": "conversations(filter:\"showUnreadOnly\")",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": "showUnreadOnly"
                  }
                ],
                "concreteType": "ConversationConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "metadata",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ConversationMetadata",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastUnreadMessageDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "totalUnreadConversationCount",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": [
                  (v15/*: any*/)
                ],
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v16/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "firstSessionDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isVip",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isVerifiedTrade",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "verifiedTradeStatus",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "authMetadata",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserExistsMetadataType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "emailOnly",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasPassword",
                        "args": null,
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "profile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Profile",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "firstName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastName",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalMessagesToDealers",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "tradeFirm",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TradeFirmType",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "profileStatus",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "rewards",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "currentProgram",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ParentProgram",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "programInfo",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "LoyaltyProgram",
                                "plural": false,
                                "selections": [
                                  (v19/*: any*/),
                                  (v1/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v1/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "publicProfile",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmPublicProfileType",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "urlLabel",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "members",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmMemberType",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "userId",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "publicProfileManager",
                            "args": null,
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "mentionMeTagParameters",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "mentionMeTagParameters",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "ciphertext",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "nonce",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "isTrade",
                    "name": "hasPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_VERIFIED_TRADE"
                      }
                    ],
                    "storageKey": "hasPermission(name:\"B_VERIFIED_TRADE\")"
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "hasVipPermission",
                    "name": "hasPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_VIP_CHECKOUT"
                      }
                    ],
                    "storageKey": "hasPermission(name:\"B_VIP_CHECKOUT\")"
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "roles",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserRoles",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "roleList",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Role",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          (v16/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "userData",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserRoleData",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "userStatus",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserRoleUserData",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v1/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "conversationSummary",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Summary",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "unread",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "activePromotion",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Promotion",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "adjustmentRateList",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": true,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "reference",
                            "args": null,
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ]
                      },
                      (v6/*: any*/),
                      (v19/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "flatAdjustmentRate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FlatAdjustmentRate",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "rate",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "plural": false,
                            "selections": (v21/*: any*/)
                          },
                          (v1/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "percentAdjustmentRate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PercentAdjustmentRate",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "rate",
                            "args": null,
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ]
                      },
                      (v1/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "activityFeed",
                    "storageKey": "activityFeed(elementTypes:[\"PENDING_FEEDBACK\",\"TRADE_REWARD\",\"TRADE_REWARD_PRORATED\",\"TRADE_REWARD_PROGRAM\",\"AUTOMATED_OFFER\"],first:3)",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "elementTypes",
                        "value": [
                          "PENDING_FEEDBACK",
                          "TRADE_REWARD",
                          "TRADE_REWARD_PRORATED",
                          "TRADE_REWARD_PROGRAM",
                          "AUTOMATED_OFFER"
                        ]
                      },
                      (v13/*: any*/)
                    ],
                    "concreteType": "ActivityFeedConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ActivityFeedEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ActivityFeedElement",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "type",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "eventDate",
                                "args": null,
                                "storageKey": null
                              },
                              (v6/*: any*/),
                              (v1/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "apiType",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "status",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "anchors",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Anchor",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "sourceType",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "source",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v1/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "type": "TradeFirmReward",
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "rewardEarned",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "FinancialAmount",
                                            "plural": false,
                                            "selections": (v21/*: any*/)
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "ParentProgram",
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "programInfo",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "LoyaltyProgram",
                                            "plural": false,
                                            "selections": [
                                              (v11/*: any*/),
                                              (v19/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "iconUri",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              (v1/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "OrderFeedback",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "token",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "transaction",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Transaction",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "item",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "Item",
                                                "plural": false,
                                                "selections": [
                                                  (v22/*: any*/),
                                                  (v23/*: any*/),
                                                  (v1/*: any*/)
                                                ]
                                              },
                                              (v1/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "type": "Transaction",
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "summary",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "TransactionSummaryObject",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "offerDiscountPercentage",
                                                "args": null,
                                                "storageKey": null
                                              }
                                            ]
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "item",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Item",
                                            "plural": false,
                                            "selections": [
                                              (v6/*: any*/),
                                              (v22/*: any*/),
                                              (v23/*: any*/),
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "pricing",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "ItemPricing",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "retailPrice",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "FinancialAmount",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "convertedAmountList",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "ConvertedAmountList",
                                                        "plural": true,
                                                        "selections": [
                                                          (v20/*: any*/),
                                                          (v18/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v1/*: any*/)
                                            ]
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "mostRecentOffer",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Offer",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "amountPerItem",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "FinancialAmount",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "convertedAmountList",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ConvertedAmountList",
                                                    "plural": true,
                                                    "selections": (v21/*: any*/)
                                                  }
                                                ]
                                              },
                                              (v1/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "preferences",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserPreferences",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "shareActivities",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "fetchUserRecentHistoryItem",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "recentHistoryItems",
                        "storageKey": null,
                        "args": (v24/*: any*/),
                        "concreteType": "RecentHistoryItemsConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "RecentHistoryItemsEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "contemporaryTrackingString",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "firstPhotoWebPath",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "size",
                                        "value": "small"
                                      }
                                    ],
                                    "storageKey": "firstPhotoWebPath(size:\"small\")"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "pdpURL",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v22/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "browseUrl",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "categoryCode",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v6/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "categoryPath",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "seller",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Seller",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v1/*: any*/)
                                    ]
                                  },
                                  (v1/*: any*/),
                                  (v10/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "cursor",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pageInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "endCursor",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hasNextPage",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedHandle",
                        "alias": null,
                        "name": "recentHistoryItems",
                        "args": (v24/*: any*/),
                        "handle": "connection",
                        "key": "getRecentHistory_recentHistoryItems",
                        "filters": [
                          "excludeItemPks"
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": "vipChatEmail",
                "name": "userRelationships",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "relationshipType",
                    "value": "VIP"
                  },
                  (v8/*: any*/)
                ],
                "concreteType": "UserRelationship",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "userDataB",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "VipRepData",
                        "selections": (v25/*: any*/)
                      }
                    ]
                  },
                  (v1/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": "tradeChatEmail",
                "name": "userRelationships",
                "storageKey": null,
                "args": (v9/*: any*/),
                "concreteType": "UserRelationship",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "userDataB",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "TradeRepData",
                        "selections": (v25/*: any*/)
                      }
                    ]
                  },
                  (v1/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": "allTransactions",
                "name": "transactions",
                "storageKey": null,
                "args": [
                  (v26/*: any*/),
                  (v27/*: any*/)
                ],
                "concreteType": "TransactionConnection",
                "plural": false,
                "selections": (v14/*: any*/)
              },
              {
                "kind": "LinkedField",
                "alias": "initiatedTransactions",
                "name": "transactions",
                "storageKey": null,
                "args": [
                  (v26/*: any*/),
                  (v27/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "viewName",
                    "value": "buyerTracking.initiated"
                  }
                ],
                "concreteType": "TransactionConnection",
                "plural": false,
                "selections": (v14/*: any*/)
              },
              {
                "kind": "LinkedField",
                "alias": "submittedTransactions",
                "name": "transactions",
                "storageKey": null,
                "args": [
                  (v26/*: any*/),
                  (v27/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "viewName",
                    "value": "buyerTracking.submitted"
                  }
                ],
                "concreteType": "TransactionConnection",
                "plural": false,
                "selections": (v14/*: any*/)
              },
              {
                "kind": "LinkedField",
                "alias": "confirmedTransactions",
                "name": "transactions",
                "storageKey": null,
                "args": [
                  (v26/*: any*/),
                  (v27/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "sort",
                    "value": "createdDate asc"
                  },
                  {
                    "kind": "Literal",
                    "name": "viewName",
                    "value": "buyerTracking.confirmed"
                  }
                ],
                "concreteType": "TransactionConnection",
                "plural": false,
                "selections": (v14/*: any*/)
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": false,
            "condition": "hasSessionCountryCode",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "regInfo",
                "name": "regionalInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "RegionalInfo",
                "plural": true,
                "selections": [
                  (v28/*: any*/),
                  (v1/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasCheckoutUserId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "transactionsCounter",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "checkoutUserId"
                  }
                ],
                "concreteType": "TransactionsCounter",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": "guestCheckoutTransactions",
                    "name": "guest",
                    "args": null,
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "hasUserId",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": "submittedTransactions",
                        "name": "submitted",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": "confirmedTransactionsMostRecent",
                        "name": "confirmed",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchRegionalInfo",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "regionalInfo",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "countryCode",
                    "variableName": "userCountryCode"
                  },
                  (v15/*: any*/),
                  (v29/*: any*/)
                ],
                "concreteType": "RegionalInfo",
                "plural": true,
                "selections": [
                  (v17/*: any*/),
                  (v28/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "incomeLevel",
                    "storageKey": null,
                    "args": [
                      (v29/*: any*/)
                    ],
                    "concreteType": "IncomeLevel",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "incomeBracket",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "incomePercentile",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  (v18/*: any*/),
                  (v1/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "headerRootQuery",
    "id": "ferrum/255.0.0-2020-03-10T14:28:54.909Z/headerRootQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '71f3b7a0161ee671eea01772362d0ce4';
export default node;
